const contentHome = () => import('@/pages/content/home/index.vue');

export default [{
    path: '/content/home',
    component: contentHome,
    meta: [{
        name: '内容管理',
		activeRoute: '/content/manage'
    },
    {
        name: '首页中部资源位',
        activeRoute: '/content/home'
    }]
}];